import * as actions from "../actions";

const initialState = {
  place: "br",
  color: "danger",
  open: false,
  text: "TODO",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //APP ACTIONS
    case actions.SHOW_MESSAGE:
      return {
        ...state,
        open: true,
        ...action.message,
      };

    case actions.CLOSE_MESSAGE:
      return {
        ...state,
        open: false,
      };

    default:
      return state;
  }
};

export default reducer;
